export default "__VITE_ASSET__tdRxHJG1__"